export default __webpack_public_path__ + "static/media/web-mobile-crowd.50a7e3d6.svg";